module.exports = __webpack_public_path__ + "img/voice-thumb1.c3f56b9.jpg";